import { Card, CardBody, CardHeader, Row, Col, Badge, Label, Input, FormGroup } from 'reactstrap';
import { RefreshCcw, CheckCircle, Clock, Layout, DollarSign, MapPin } from 'lucide-react';

const Icons = {
  Layout: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>
  ),
  CheckCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
  ),
  Unlock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
  ),
  Lock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
  ),
  Maximize: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>
  ),
  DollarSign: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
  ),
  Zap: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
  ),
  Car: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>
  ),
  Trash2: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
  ),
  XCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
  ),
  MapPin: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
  )
};

const Totalizador = ({
  totaisGerais,
  totaisFiltrados,
  paisesOptions = [],
  estadosOptions = [],
  cidadesOptions = [],
  paisSelecionado,
  onPaisChange,
  estadoSelecionado,
  onEstadoChange,
  cidadeSelecionada,
  onCidadeChange,
  feiraRenovada,
  corLivre,
  corPendenteRenovacao,
  corRenovacao,
  corReservado,
  corVendido
}) => {
  
  const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);
  const formatNumber = (val) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(val || 0);

  const hasValue = (...values) => {
  return values.some((value) => Number(value || 0) > 0);
};

const mostrarKVA = hasValue(
  totaisGerais.valorKVA,
  totaisGerais.valorKVAProjetado,
  totaisGerais.quantidadeKVA,
  totaisGerais.quantidadeKVAProjetado
);

const mostrarEstacionamento = hasValue(
  totaisGerais.valorEstacionamento,
  totaisGerais.valorEstacionamentoProjetado,
  totaisGerais.quantidadeEstacionamento,
  totaisGerais.quantidadeEstacionamentoProjetado
);

const totaisAdicionais = totaisGerais.totaisAdicionais || {};
const totaisAdicionaisProjetados =
  totaisGerais.totaisAdicionaisProjetados || {};

const nomesAdicionais = Array.from(
  new Set([
    ...Object.keys(totaisAdicionais),
    ...Object.keys(totaisAdicionaisProjetados),
  ])
);

const adicionaisParaExibir = nomesAdicionais
  .map((nome) => ({
    nome,
    valorReal: Number(totaisAdicionais[nome] || 0),
    valorProjetado: Number(
      totaisAdicionaisProjetados[nome] || 0
    ),
  }))
  .filter(
    (adicional) =>
      adicional.valorReal > 0 ||
      adicional.valorProjetado > 0
  );

const mostrarServicosTaxas =
  mostrarKVA ||
  mostrarEstacionamento ||
  adicionaisParaExibir.length > 0;

  const formatarNomeAdicional = (nome) => {
    return String(nome || 'Adicional')
      .trim()
      .toLocaleLowerCase('pt-BR')
      .replace(/(^|\s)\S/g, (letra) => letra.toLocaleUpperCase('pt-BR'));
  };
  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      {/* Cabeçalho */}
      <div className="row mb-4 align-items-center">
        <div className="col">
          <h4 className="fw-bold text-primary m-0 d-flex align-items-center gap-2">
            <Icons.Layout /> TOTAIS GERAIS DO RELATÓRIO
          </h4>
          <p className="text-muted small m-0 italic">Resumo consolidado dos espaços e metragens</p>
        </div>
        <div className="col-auto">
          <div className="bg-white border p-2 px-3 rounded shadow-sm d-flex align-items-center gap-2">
            <div className="text-primary"><Icons.CheckCircle /></div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '9px' }}>Total de Itens</div>
              <div className="fw-bold h6 m-0">{totaisGerais.totalEspacos}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 1. Status dos Espaços */}
      <div className="mb-4">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div style={{width: '4px', height: '18px', backgroundColor: '#0d6efd', borderRadius: '2px'}}></div>
          <h6 className="fw-bold text-muted text-uppercase mb-0" style={{fontSize: '12px', letterSpacing: '1px'}}>Status dos Espaços</h6>
        </div>
        <div className="row g-3">
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Layout />} title="Total" value={totaisGerais.totalEspacos} color={"primary"} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.CheckCircle />} title="Vendidos" value={totaisGerais.espacosVendidos} color={corVendido} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Unlock />} title="Livres" value={totaisGerais.faltam} color={corLivre} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Lock />} title="Reservados" value={totaisGerais.espacosReservados} color={corReservado} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard
              icon={<Icons.XCircle />}
              title="Cancelamentos"
              value={totaisGerais.espacosCancelados || 0}
              color="#dc3545"
            />
          </div>

          { feiraRenovada && (
            <>
                <div className="col-6 col-md-3">
                    <StatCard icon={<Icons.Unlock />} title="Pend.Ren." value={totaisGerais.espacosPendenteRenovacao} color={corPendenteRenovacao} />
                </div>
                <div className="col-6 col-md-3">
                    <StatCard icon={<Icons.Lock />} title="Renovados" value={totaisGerais.espacosRenovados} color={corRenovacao} />
                </div>
            </>
          )}
        </div>
      </div>

      {/* 2. Metragem */}
      <div className="mb-4">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div style={{width: '4px', height: '18px', backgroundColor: '#198754', borderRadius: '2px'}}></div>
          <h6 className="fw-bold text-muted text-uppercase mb-0" style={{fontSize: '12px', letterSpacing: '1px'}}>Análise de Metragem (m²)</h6>
        </div>
        <div className="row g-2">
            <div className="col"><MiniCard title="Total" value={formatNumber(totaisGerais.metragemTotal)} theme="primary" /></div>
            <div className="col"><MiniCard title="Vendida" value={formatNumber(totaisGerais.metragemVendida)} theme="success" cor={corVendido}/></div>
            <div className="col"><MiniCard title="Bonificada" value={formatNumber(totaisGerais.metragemBonificada)} theme="secondary" /></div>
            <div className="col"><MiniCard title="Cobrada" value={formatNumber(totaisGerais.metragemCobrada)} theme="primary" /></div>
        </div>
      </div>

      {/* 3. Financeiro e Serviços */}
      <div className="row mb-4">
        <div className="col-lg-7 mb-4 mb-lg-0">
          <div className="card h-100 shadow-sm border-0 rounded-4">
            <div className="card-header bg-transparent border-0 pt-4 px-4">
              <div className="d-flex align-items-center gap-2">
                <div className="bg-success text-white p-2 rounded shadow-sm"><Icons.DollarSign /></div>
                <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Resumo Financeiro</h6>
              </div>
            </div>
            <div className="card-body p-4">
              <div className="pb-4 mb-4 border-bottom">
                <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                  <div>
                    <p className="text-muted small fw-bold text-uppercase mb-1">Valor Total Contratado / Financeiro</p>
                    <h2 className="fw-bold text-dark mb-0">{formatCurrency(totaisGerais.valorTotalVendido)}</h2>
                    <div className="text-muted small mt-2">
                      Calculado pelos itens: {formatCurrency(totaisGerais.valorCalculadoItens)}
                    </div>
                    <div className={`small fw-bold ${(totaisGerais.diferencaFinanceira || 0) >= 0 ? 'text-success' : 'text-danger'}`}>
                      Diferença negociação: {formatCurrency(totaisGerais.diferencaFinanceira)}
                    </div>
                  </div>
                  <div className="text-md-end">
                    <p className="text-muted small fw-bold text-uppercase mb-1">Valor Total Projetado</p>
                    <h2 className="fw-bold text-success mb-0">{formatCurrency(totaisGerais.valorTotalProjetado)}</h2>
                  </div>
                </div>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded border-start border-4 border-primary h-100">
                    <p className="text-muted small fw-bold text-uppercase mb-1">Valor Espaço</p>
                    <h5 className="fw-bold mb-1">{formatCurrency(totaisGerais.valorEspaco)}</h5>
                    <div className="text-muted small">Projetado: {formatCurrency(totaisGerais.valorEspacoProjetado)}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded h-100">
                    <p className="text-muted small fw-bold text-uppercase mb-1">Taxas e Outros</p>
                    <h5 className="fw-bold mb-1">{formatCurrency(totaisGerais.valorTaxasOutros)}</h5>
                    <div className="text-muted small">Projetado: {formatCurrency(totaisGerais.valorTaxasOutrosProjetado)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-lg-5">
          <div className="card h-100 shadow-sm border-0 rounded-4">
            <div className="card-header bg-transparent border-0 pt-4 px-4">
              <div className="d-flex align-items-center gap-2">
                <div className="bg-warning text-white p-2 rounded shadow-sm"><Icons.Zap /></div>
                <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Serviços e Taxas</h6>
              </div>
            </div>
            <div className="card-body p-4 d-flex flex-column gap-3">
              <ServiceRowPremium
                icon={<Icons.Zap />}
                color="#fbbf24"
                label="Valor KVA"
                atualValor={formatCurrency(totaisGerais.valorKVA)}
                atualQtd={`${totaisGerais.quantidadeKVA || 0} un.`}
                projetadoValor={formatCurrency(totaisGerais.valorKVAProjetado)}
                projetadoQtd={`${totaisGerais.quantidadeKVAProjetado || 0} un.`}
              />

              <ServiceRowPremium
                icon={<Icons.Car />}
                color="#09056f"
                label="Estacionamento"
                atualValor={formatCurrency(totaisGerais.valorEstacionamento)}
                atualQtd={`${totaisGerais.quantidadeEstacionamento || 0} un.`}
                projetadoValor={formatCurrency(totaisGerais.valorEstacionamentoProjetado)}
                projetadoQtd={`${totaisGerais.quantidadeEstacionamentoProjetado || 0} un.`}
              />

              <ServiceRowPremium
                icon={<Icons.Trash2 />}
                color="#ef5b45"
                label="Taxa Limpeza"
                atualValor={formatCurrency(totaisGerais.valorLimpeza)}
                projetadoValor={formatCurrency(totaisGerais.valorLimpezaProjetado)}
              />

              {(totaisGerais.valorMerchan > 0 || totaisGerais.valorMerchanProjetado > 0) && (
                <ServiceRowPremium
                  icon={<Icons.DollarSign />}
                  color="#16a34a"
                  label="Merchan"
                  atualValor={formatCurrency(totaisGerais.valorMerchan)}
                  projetadoValor={formatCurrency(totaisGerais.valorMerchanProjetado)}
                />
              )}
            </div>
          </div>
        </div> */}
        
        {mostrarServicosTaxas && (
  <div className="col-lg-5">
    <div className="card h-100 shadow-sm border-0 rounded-4">
      <div className="card-header bg-transparent border-0 pt-4 px-4">
        <div className="d-flex align-items-center gap-2">
          <div className="bg-warning text-white p-2 rounded shadow-sm">
            <Icons.Zap />
          </div>
          <h6 className="fw-bold mb-0 text-uppercase tracking-wider">
            Serviços e Taxas
          </h6>
        </div>
      </div>

      <div className="card-body p-4 d-flex flex-column gap-3">
        {mostrarKVA && (
          <ServiceRowPremium
            icon={<Icons.Zap />}
            color="#fbbf24"
            label="Valor KVA"
            atualValor={formatCurrency(totaisGerais.valorKVA)}
            atualQtd={`${totaisGerais.quantidadeKVA || 0} un.`}
            projetadoValor={formatCurrency(totaisGerais.valorKVAProjetado)}
            projetadoQtd={`${totaisGerais.quantidadeKVAProjetado || 0} un.`}
          />
        )}

        {mostrarEstacionamento && (
          <ServiceRowPremium
            icon={<Icons.Car />}
            color="#09056f"
            label="Estacionamento"
            atualValor={formatCurrency(totaisGerais.valorEstacionamento)}
            atualQtd={`${totaisGerais.quantidadeEstacionamento || 0} un.`}
            projetadoValor={formatCurrency(totaisGerais.valorEstacionamentoProjetado)}
            projetadoQtd={`${totaisGerais.quantidadeEstacionamentoProjetado || 0} un.`}
          />
        )}

        {adicionaisParaExibir.map((adicional) => (
          <ServiceRowPremium
            key={adicional.nome}
            icon={<Icons.DollarSign />}
            color="#16a34a"
            label={formatarNomeAdicional(adicional.nome)}
            atualValor={formatCurrency(adicional.valorReal)}
            projetadoValor={formatCurrency(adicional.valorProjetado)}
          />
        ))}
      </div>
    </div>
  </div>
)}
      </div>

      {/* 4. Filtro Geográfico */}
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-header bg-transparent border-0 pt-4 px-4 d-flex align-items-center gap-2">
          <div className="bg-dark text-white p-2 rounded shadow-sm"><Icons.MapPin /></div>
          <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Localização de Vendas</h6>
        </div>
        
        <div className="card-body p-4">
          <div className="row g-3 mb-4 pb-4 border-bottom border-dashed">
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">País</label>
              <Input type="select" className="form-select-sm border-2" 
                value={paisSelecionado} 
                onChange={(e) => onPaisChange(e.target.value)}>
                <option value="">Todos os países</option>
                {paisesOptions.map((pais, index) => (<option key={`${pais.sigla}-${index}`} value={pais.sigla}>{pais.nome}</option>))}
              </Input>
            </div>
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">Estado</label>
              <Input type="select" className="form-select-sm border-2" 
                value={estadoSelecionado} 
                onChange={(e) => onEstadoChange(e.target.value)} 
                disabled={paisSelecionado !== 'BR'}>
                <option value="">Todos os estados</option>
                {estadosOptions.map((estado) => (<option key={estado.sigla} value={estado.sigla}>{estado.nome}</option>))}
              </Input>
            </div>
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">Cidade</label>
              <Input type="select" className="form-select-sm border-2" 
                value={cidadeSelecionada} 
                onChange={(e) => onCidadeChange(e.target.value)} 
                disabled={!estadoSelecionado}>
                <option value="">Todas as cidades</option>
                {cidadesOptions.map((cidade) => (<option key={cidade.id} value={cidade.nome}>{cidade.nome}</option>))}
              </Input>
            </div>
          </div>
          {totaisFiltrados ? (
            <Row className="text-center g-4">
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">CLIENTES NO LOCAL</p>
                <h4 className="text-primary mb-1">{totaisFiltrados.clientes}</h4>
                <Badge color="primary-subtle" className="text-primary border border-primary-subtle">
                    {formatNumber(totaisFiltrados.percentualClientes)}% do total
                </Badge>
                </div>
            </Col>
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">ÁREA OCUPADA</p>
                <h4 className="text-success mb-1">{formatNumber(totaisFiltrados.metragem)} m²</h4>
                <Badge color="success-subtle" className="text-success border border-success-subtle">
                    {formatNumber(totaisFiltrados.percentualMetragem)}% da área
                </Badge>
                </div>
            </Col>
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">VALOR CONTRATADO</p>
                <h4 className="text-info mb-1">{formatCurrency(totaisFiltrados.valor)}</h4>
                <Badge color="info-subtle" className="text-info border border-info-subtle">
                    {formatNumber(totaisFiltrados.percentualValor)}% da receita
                </Badge>
                </div>
            </Col>
            </Row>
        ) : (
            <div className="text-center py-4 bg-light rounded-3 border border-dashed">
            <p className="text-muted mb-0">Utilize os filtros acima para detalhar o desempenho por região.</p>
            </div>
        )}
        </div>
      </div>
    </div>
  );
};

// Sub-componentes customizados
const StatCard = ({ icon, title, value, color }) => (
  <div className="card border-0 shadow-sm rounded-4 h-100">
    <div className="card-body">
      <div className={`text-${color} mb-2`}>
        <div className={`bg-opacity-10 p-2 rounded-3 d-inline-block border border-opacity-25`} style={{ backgroundColor: `${color}15`, color: color }}>
          {icon}
        </div>
      </div>
      <div className="text-muted small fw-bold text-uppercase" style={{fontSize: '10px'}}>{title}</div>
      <h3 className="fw-bold m-0">{value}</h3>
    </div>
  </div>
);

const MiniCard = ({ title, value, theme, cor }) => (
  <div className={`p-3 rounded-3 border border-2 border-${theme} border-opacity-25 bg-${theme} bg-opacity-10 text-center h-100`} style={{ backgroundColor: `${cor}15`, color: cor }}>
    <div className={`text-${theme} small fw-bold text-uppercase mb-1`} style={{fontSize: '9px'}}>{title}</div>
    <div className="fw-bold text-dark">{value}</div>
  </div>
);

const ServiceMetricCard = ({
  icon,
  color,
  label,
  atualValor,
  atualQtd,
  projetadoValor,
  projetadoQtd,
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        alignItems: "stretch",
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        borderRadius: "18px",
        padding: "18px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
      }}
    >
      <div
        style={{
          minWidth: "58px",
          height: "58px",
          borderRadius: "14px",
          background: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
          flexShrink: 0,
        }}
      >
        {icon}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "13px",
            fontWeight: 800,
            color: "#64748b",
            textTransform: "uppercase",
            letterSpacing: "0.4px",
            marginBottom: "12px",
          }}
        >
          {label}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "12px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "14px",
              padding: "14px",
            }}
          >
            <div
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: "#64748b",
                textTransform: "uppercase",
                marginBottom: "6px",
              }}
            >
              Atual
            </div>

            <div
              style={{
                fontSize: "18px",
                fontWeight: 900,
                color: "#0f172a",
                lineHeight: 1.2,
              }}
            >
              {atualValor}
            </div>

            {atualQtd ? (
              <div
                style={{
                  marginTop: "6px",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: 600,
                }}
              >
                {atualQtd}
              </div>
            ) : null}
          </div>

          <div
            style={{
              background: "#f1f5f9",
              border: "1px dashed #cbd5e1",
              borderRadius: "14px",
              padding: "14px",
            }}
          >
            <div
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: "#64748b",
                textTransform: "uppercase",
                marginBottom: "6px",
              }}
            >
              Projetado
            </div>

            <div
              style={{
                fontSize: "18px",
                fontWeight: 900,
                color: "#334155",
                lineHeight: 1.2,
              }}
            >
              {projetadoValor}
            </div>

            {projetadoQtd ? (
              <div
                style={{
                  marginTop: "6px",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: 600,
                }}
              >
                {projetadoQtd}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const ServiceRowPremium = ({
  icon,
  color = "#0d6efd",
  label,
  atualValor,
  atualQtd,
  projetadoValor,
  projetadoQtd,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "5px",
      padding: "6px",
      borderRadius: "16px",
      background: "#f8fafc",
      border: "1px solid #e5e7eb",
      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      flexWrap: "wrap",
    }}
  >
    <div
      style={{
        width: "52px",
        height: "52px",
        borderRadius: "14px",
        background: color,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {icon}
    </div>

    <div style={{ flex: "1 1 220px", minWidth: 0 }}>
      <div
        style={{
          fontSize: "8px",
          fontWeight: 800,
          color: "#7c8494",
          textTransform: "uppercase",
          letterSpacing: "0.4px",
          marginBottom: "4px",
        }}
      >
        {label}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <strong
          style={{
            fontSize: "16px",
            lineHeight: 1.1,
            color: "#1f2933",
            fontWeight: 900,
          }}
        >
          {atualValor}
        </strong>

        {atualQtd ? (
          <span
            style={{
              fontSize: "10px",
              color: "#7c8494",
              fontWeight: 700,
            }}
          >
            {atualQtd}
          </span>
        ) : null}
      </div>
    </div>

    <div
      style={{
        marginLeft: "auto",
        background: "#ffffff",
        border: "1px solid #dbe1ea",
        borderRadius: "999px",
        padding: "8px 12px",
        fontSize: "10px",
        fontWeight: 800,
        color: "#64748b",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ color: "#94a3b8", fontWeight: 800 }}>Projetado:</span>{" "}
      <span style={{ color: "#334155" }}>{projetadoValor}</span>
      {projetadoQtd ? (
        <span style={{ color: "#94a3b8", marginLeft: "4px" }}>
          ({projetadoQtd})
        </span>
      ) : null}
    </div>
  </div>
);

const ServiceRow = ({ icon, color, label, value, sub }) => (
  <div className="d-flex align-items-center gap-3 p-3 bg-light rounded border border-opacity-50">
    <div className={`bg-${color} text-white p-2 rounded shadow-sm flex-shrink-0`}>{icon}</div>
    <div className="flex-grow-1 min-w-0">
      <div className="text-muted small fw-bold text-uppercase" style={{fontSize: '9px'}}>{label}</div>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-1">
        <span className="fw-bold">{value}</span>
        {sub && <span className="text-muted small italic" style={{fontSize: '10px'}}>{sub}</span>}
      </div>
    </div>
  </div>
);

export default Totalizador;